module.exports = __webpack_public_path__ + "static/img/lifestyle_14.6bd8f0bf.jpg";